var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('p',{staticClass:"h5"},[_vm._v("Loading "+_vm._s(_vm.topic)+"...")]),_c('img',{attrs:{"src":"/assets/loading.gif"}})])}
var staticRenderFns = []

export { render, staticRenderFns }